<template>
	<v-card>
		<v-toolbar density="compact" elevation="0">
			<template v-if="$slots.prepend" #prepend>
				<slot name="prepend"></slot>
			</template>
			<template #title>
				<v-toolbar-title class="text-body-1">
					{{ title }}
				</v-toolbar-title>
			</template>

			<v-btn
				v-if="saveBtn"
				:disabled="src === null"
				stacked
				@click.stop="$emit('save')"
			>
				<v-icon icon="far fa-save"></v-icon>
			</v-btn>
			<v-btn v-if="closeBtn" stacked @click.stop="$emit('close')">
				<v-icon icon="far fa-xmark"></v-icon>
			</v-btn>
		</v-toolbar>
		<v-card-item>
			<BaseImage
				v-bind="$attrs"
				:src="src"
				show-file-not-found-text
				error-info="component.baseImage.errorInfo"
			></BaseImage>
		</v-card-item>
	</v-card>
</template>

<script setup lang="ts">
import BaseImage, { type ImageSrc } from './BaseImage.vue'

type Props = {
	title?: string
	src: ImageSrc
	saveBtn?: boolean
	closeBtn?: boolean
}

defineProps<Props>()

defineEmits(['save', 'close'])
</script>
<style></style>
